<script lang="ts" setup>
interface Props {
  modelValue: boolean
  title: string
  text?: string
  confirmText?: string
  cancelText?: string
  color?: string
  loading?: boolean
  maxWidth?: number | string
}

interface Emits {
  (e: 'update:modelValue', value: boolean): void
  (e: 'confirm'): void
  (e: 'cancel'): void
}

const props = withDefaults(defineProps<Props>(), {
  text: '',
  confirmText: 'Подтвердить',
  cancelText: 'Отменить',
  color: 'primary',
  loading: false,
  maxWidth: 400,
})

const emit = defineEmits<Emits>()

const isOpen = computed({
  get: () => props.modelValue,
  set: value => emit('update:modelValue', value),
})

const onConfirm = () => {
  emit('confirm')
}

const onCancel = () => {
  emit('cancel')
}
</script>

<template>
  <VDialog
    v-model="isOpen"
    :max-width="maxWidth"
    persistent
  >
    <VCard class="pa-5">
      <VCardTitle class="text-h6 font-weight-bold mb-2">
        {{ title }}
      </VCardTitle>

      <VCardText
        v-if="text"
        class="text-body-2 text-medium-emphasis pb-0"
      >
        {{ text }}
      </VCardText>

      <slot />

      <VCardActions class="mt-4 justify-end gap-3 pa-0">
        <VBtn
          variant="outlined"
          color="grey"
          :disabled="loading"
          @click="onCancel"
        >
          {{ cancelText }}
        </VBtn>

        <VBtn
          variant="elevated"
          :color="color"
          :loading="loading"
          @click="onConfirm"
        >
          {{ confirmText }}
        </VBtn>
      </VCardActions>
    </VCard>
  </VDialog>
</template>

<style scoped>
.v-card {
  border-radius: 12px;
}

.v-btn {
  text-transform: none;
  font-weight: 500;
}
</style>
